import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import styles from './HorizontalContainer.module.scss';

function HorizontalContainer({ children, className }) {
  const wrapperRef = useRef();
  const containerRef = useRef();

  return (
    <div
      ref={wrapperRef}
      className={`${styles.wrapper} ${className || ''}`}
    >
      <div
        ref={containerRef}
        className={`${styles.container} flex a-center`}
      >
        {children}
      </div>
    </div>
  );
}

HorizontalContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

HorizontalContainer.defaultProps = {
  children: null,
  className: null,
};

export default HorizontalContainer;
